import { render, staticRenderFns } from "./msb.vue?vue&type=template&id=0a4c0fd4&scoped=true"
import script from "./msb.vue?vue&type=script&lang=js"
export * from "./msb.vue?vue&type=script&lang=js"
import style0 from "./msb.vue?vue&type=style&index=0&id=0a4c0fd4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a4c0fd4",
  null
  
)

export default component.exports